import React, { FunctionComponent, useCallback } from 'react';
import ModalWithHeader from '../../../../../../common/components/presentation/ModalWithHeader';
import { Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import customiseSelectors from '../../../../../store/selectors/customiseSelectors';
import { customiseActions } from '../../../../../store/reducers/customiseReducer';
import SpecificationsContentContainer from './SpecificationsContentContainer';
import specificationsModalStyles from './specificationsModalStyles';
import Translation from '../../../../../../common/components/translation/Translation';

const SpecificationsModal: FunctionComponent = () => {
  const styles = specificationsModalStyles();
  const dispatch = useDispatch();
  const isSpecificationsFeaturesModalOpen = useSelector(customiseSelectors.getSpecificationsFeaturesModal);

  const toggleModal = useCallback((shouldOpen: boolean) => {
    dispatch(customiseActions.setSpecificationsFeaturesModal(shouldOpen));
  }, []);

  return (
    <ModalWithHeader
      open={isSpecificationsFeaturesModalOpen}
      toggleModal={toggleModal}
      title={
        <Typography className={styles.title} data-test="customise:specifications_modal_title">
          <Translation id="spc.customise.fullSpecificationsAndFeaturesModal.title" />
        </Typography>
      }
    >
      <SpecificationsContentContainer />
    </ModalWithHeader>
  );
};

export default SpecificationsModal;
